var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "trackPaginate"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isHandoverShipmentListLoader,
      "text": "Please Wait Loading Shipments..."
    },
    on: {
      "update:active": function($event) {
        _vm.isHandoverShipmentListLoader = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "b-table table table-bordered pending-for-delivery-ShipmentList"
  }, [_c('thead', {
    staticClass: "thead-default"
  }, [_c('tr', {
    staticClass: "text-center"
  }, [_c('th', [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', [_vm._v("Shipment Type")]), _vm._v(" "), _c('th', [_vm._v("Handover Date")]), _vm._v(" "), _c('th', [_vm._v("Assign Date")]), _vm._v(" "), (_vm.isRemoveOption) ? _c('th', [_vm._v("   ")]) : _vm._e()])]), _vm._v(" "), _c('tbody', [(_vm.HandoverShipmentList.length > 0) ? _vm._l((_vm.HandoverShipmentList), function(row) {
    return _c('tr', {
      staticClass: "text-center"
    }, [_c('td', [_vm._v(_vm._s(row.shippingid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.shipmenttype))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(row.handoverdate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(row.AssignDate)))]), _vm._v(" "), (_vm.isRemoveOption) ? _c('td', [_c('i', {
      staticClass: "fa fa-times-circle",
      staticStyle: {
        "cursor": "pointer",
        "font-size": "18px"
      },
      on: {
        "click": function($event) {
          return _vm.removeShipment(row.shippingid)
        }
      }
    })]) : _vm._e()])
  }) : [_vm._m(0)]], 2)]), _vm._v(" "), _c('paginate', {
    ref: "paginate",
    attrs: {
      "page-count": _vm.pageCount1,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "6",
      "align": "center"
    }
  }, [_vm._v("No record found")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-531b5184","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/common/HanoverShipmentList.vue
// module id = 1034
// module chunks = 1